"use client";
import { useState, useEffect } from "react";
import Users from "../assets/heart11.png";
import Eye from "../assets/star111.png";
import EyeOff from "../assets/global111.png";
import User from "../assets/dollar111.png";
import Sidebar from "./Sidebar";
import api from "../sever/Api";

export default function JohariWindowResults({
  selfSelected,
  othersSelected,
  allAdjectives,
  userId,
}) {
  const [showAllUnknown, setShowAllUnknown] = useState(false);
  const [feedbackData, setFeedbackData] = useState({});
  const [showFeedbackDetails, setShowFeedbackDetails] = useState(false);

  useEffect(() => {
    if (userId) {
      fetchFeedbackFromAPI();
    }
  }, [userId]);

  const fetchFeedbackFromAPI = async () => {
    try {
      const response = await api.get(`/api/johari-feedback/${userId}`);
      // Convert API response to the expected format
      const feedbackMap = {};
      response.data.feedback.forEach((item, index) => {
        feedbackMap[item.feedbackId] = {
          adjectives: item.adjectives,
          name: item.name,
          relationship: item.relationship,
          submittedAt: item.submittedAt
        };
      });
      setFeedbackData(feedbackMap);
    } catch (error) {
      console.error('Error fetching feedback:', error);
    }
  };

  // Refresh feedback data periodically to get new submissions
  useEffect(() => {
    if (!userId) return;

    const interval = setInterval(() => {
      fetchFeedbackFromAPI();
    }, 10000); // Refresh every 10 seconds

    return () => clearInterval(interval);
  }, [userId]);

  // Support both legacy schema (id -> [adjectives]) and new schema (id -> {adjectives, name,...})
  const normalizeFeedbackMap = (rawMap) => {
    const normalized = {};
    Object.entries(rawMap || {}).forEach(([id, value]) => {
      if (Array.isArray(value)) {
        normalized[id] = { adjectives: value, name: `Person ${Object.keys(rawMap).indexOf(id) + 1}` };
      } else if (value && Array.isArray(value.adjectives)) {
        normalized[id] = value;
      }
    });
    return normalized;
  };

  const normalizedFeedback = normalizeFeedbackMap({ ...othersSelected, ...feedbackData });
  const allOthersSelections = Object.values(normalizedFeedback).flatMap((f) => f.adjectives || []);
  const uniqueOthersSelections = [...new Set(allOthersSelections)];

  // ✅ Window areas
  const openArea = selfSelected.filter((adj) => uniqueOthersSelections.includes(adj));
  const blindSpot = uniqueOthersSelections.filter((adj) => !selfSelected.includes(adj));
  const hiddenArea = selfSelected.filter((adj) => !uniqueOthersSelections.includes(adj));
  const unknownArea = allAdjectives.filter(
    (adj) => !selfSelected.includes(adj) && !uniqueOthersSelections.includes(adj)
  );

  const getAdjectiveCount = (adjective) => {
    return allOthersSelections.filter((adj) => adj === adjective).length;
  };

  const getWhoSelected = (adjective) => {
    const selectors = [];
    Object.values(normalizedFeedback).forEach((entry, index) => {
      if ((entry.adjectives || []).includes(adjective)) {
        selectors.push(entry.name || `Person ${index + 1}`);
      }
    });
    return selectors;
  };

  const displayedUnknown = showAllUnknown ? unknownArea : unknownArea.slice(0, 20);
  const totalFeedbackProviders = Object.keys(normalizedFeedback).length;

  return (
    <>
      <div className="space-y-6">


        {/* {totalFeedbackProviders > 0 && (
        <div className="border border-green-200 bg-green-50 rounded">
          <div className="p-4 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <img src={Users} alt="users" className="w-5 h-5" />
              <span className="text-green-800 font-medium">
                {totalFeedbackProviders} friend
                {totalFeedbackProviders > 1 ? "s" : ""} provided feedback
              </span>
            </div>
            <button
              onClick={() => setShowFeedbackDetails(!showFeedbackDetails)}
              className="text-green-700 border border-green-300 px-3 py-1 rounded text-sm"
            >
              {showFeedbackDetails ? "Hide Details" : "View Details"}
            </button>
          </div>
        </div>
      )} */}

        {showFeedbackDetails && totalFeedbackProviders > 0 && (
          <div className="border border-green-200 rounded">
            <div className="px-4 py-2 border-b bg-green-100">
              <h3 className="text-green-800 font-bold flex items-center gap-2">
                <img src={Eye} alt="eye" className="w-5 h-5" />
                Individual Feedback Details
              </h3>
            </div>
            <div className="p-4 space-y-4">
              {Object.entries(normalizedFeedback).map(([personId, entry], index) => (
                <div key={personId} className="border rounded-lg p-4 bg-gray-50">
                  <div className="flex items-center gap-2 mb-3">
                    <img src={User} alt="person" className="w-4 h-4" />
                    <h4 className="font-semibold text-gray-800">{entry.name || `Person ${index + 1}`}</h4>
                    <span className="text-xs px-2 py-1 bg-gray-200 rounded">
                      {(entry.adjectives || []).length} adjectives
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {(entry.adjectives || []).map((adj) => {
                      const isInOpen = selfSelected.includes(adj);
                      const isInBlind = !selfSelected.includes(adj);
                      const style = isInOpen
                        ? "bg-blue-100 text-blue-800 border border-blue-300"
                        : isInBlind
                          ? "bg-pink-100 text-pink-800 border border-pink-300"
                          : "bg-gray-100 text-gray-800";
                      return (
                        <span key={adj} className={`px-2 py-1 rounded text-xs ${style}`}>
                          {adj}
                          {isInOpen && " (Open)"}
                          {isInBlind && " (Blind)"}
                        </span>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}



        {/* Grid with axis labels */}
        <div className="grid grid-cols-[28px_1fr_1fr] gap-4">
          <div></div>
          <div className="text-center text-gray-500 text-sm font-semibold">Known To Self</div>
          <div className="text-center text-gray-500 text-sm font-semibold">NOT Known To Self</div>

          {/* Row: Known to Others */}
          <div className="flex items-center justify-center">
            <span className="text-gray-500 text-xs font-medium" style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}>Known to Others</span>
          </div>
          {[["Open", openArea, "blue"], ["Blind", blindSpot, "pink"]].map(([title, list, color]) => (
            <div key={String(title)} className={`bg-${color}-50 border border-${color}-300 rounded min-h-[300px]`}>
              <div className={`bg-${color}-100 border-b border-${color}-300 px-4 py-2`}>
                <h3 className={`text-${color}-800 text-center font-bold`}>{title}</h3>
                <p className={`text-sm text-${color}-600 text-center`}>
                  {title === "Open"
                    ? "Adjectives you selected and others agree"
                    : "Adjectives others selected but you didn't"}
                </p>
              </div>
              <div className="p-4 flex flex-wrap gap-2">
                {list.length > 0 ? (
                  list.map((adj) => {
                    const count = getAdjectiveCount(adj);
                    const who = getWhoSelected(adj);
                    return (
                      <span
                        key={adj}
                        title={who.length > 0 ? `Selected by: ${who.join(", ")}` : ""}
                        className={`px-2 py-1 rounded text-xs ${title === "Open" ? "bg-blue-600 text-white" : "bg-pink-600 text-white"}`}
                      >
                        {adj}
                        {` (${count})`}
                      </span>
                    );
                  })
                ) : (
                  <p className={`text-${color}-600 text-sm italic`}>
                    {title === "Open" ? "No overlapping adjectives yet. Get more feedback!" : "No blind spots identified yet. Share your link!"}
                  </p>
                )}
              </div>
            </div>
          ))}

          {/* Row: NOT Known to Others */}
          <div className="flex items-center justify-center">
            <span className="text-gray-500 text-xs font-medium" style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}>NOT Known to Others</span>
          </div>
          {[["Hidden", hiddenArea, "green"], ["Unknown", displayedUnknown, "purple"]].map(([title, list, color]) => (
            <div key={String(title)} className={`bg-${color}-50 border border-${color}-300 rounded min-h-[300px]`}>
              <div className={`bg-${color}-100 border-b border-${color}-300 px-4 py-2`}>
                <h3 className={`text-${color}-800 text-center font-bold`}>{title}</h3>
                <p className={`text-sm text-${color}-600 text-center`}>
                  {title === "Hidden"
                    ? "Adjectives you selected but others didn't (Not Known to Others)"
                    : "Adjectives neither selected"}
                </p>
              </div>
              <div className="p-4 flex flex-wrap gap-2">
                {list.length > 0 ? (
                  list.map((adj) => (
                    <span key={adj} className={`px-2 py-1 rounded text-xs ${title === "Hidden" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700"}`}>{adj}</span>
                  ))
                ) : (
                  <p className={`text-${color}-600 text-sm italic`}>
                    {title === "Unknown" ? "Most adjectives remain unexplored." : "No hidden adjectives"}
                  </p>
                )}
              </div>
              {title === "Unknown" && unknownArea.length > 20 && (
                <div className="text-center mb-4">
                  <button onClick={() => setShowAllUnknown(!showAllUnknown)} className="text-purple-600 border border-purple-300 px-3 py-1 rounded text-sm">
                    {showAllUnknown ? "Show Less" : "Show All"}
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
     
      {/* Simple collapsed Feedback section under Share area for visibility */}
      {totalFeedbackProviders > 0 && (
        <div className="mt-6 border rounded bg-white">
          <div className="px-4 py-3 border-b font-semibold">Feedback</div>
          <div className="p-4 space-y-4">
            {Object.values(normalizedFeedback).map((entry, idx) => (
              <div key={idx}>
                <div className="text-sm font-medium mb-2">{entry.name || `Person ${idx + 1}`}</div>
                <div className="flex flex-wrap gap-2">
                  {(entry.adjectives || []).map((adj) => (
                    <span key={adj} className="px-2 py-1 text-xs rounded bg-gray-100">{adj}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>

  );
}
